var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStep2 = function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 518 311",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.34 283.61c6.24-1.65 66.14-17.19 74.7-20.79 8.56-3.6 13.38-9.48 11.25-20.36-.68-3.45-3.37-13.21-6.82-25.09L272.39 224l9.37 20.76s-48.62 21.4-64 27",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.04 143.29s-26.83 3.7-38.16 23.37c-8.29 14.39-22.58 60.77-26.67 79.59l34 4 19.74-62.93 11.09-44.03z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.04 290.93s1.25-41.65 3.41-56.78c2.16-15.13 9.1-70.61 4.46-79.32-4.64-8.71-10.34-7.56-25.2-11.1s-39.12-2.71-50.2 2.89c-11.08 5.6-21.47 28.24-29.76 40.14-8.52 12.17-14.29 25.48-8.49 37.06a43 43 0 0 0 16.71 17.23l3.93 67.3h94.27a130.22 130.22 0 0 0-9.13-17.42h0z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.26 295.81c37-8.67 64.77-17.93 74.93-22.2 3.16-1.33 7.68-3.61 10.11-8.3 1.63-3.15 2.12-7.08 1.14-12-.68-3.46-3.37-13.22-6.81-25.1l-28.09 6.63 9.37 20.76-64 27a16.94 16.94 0 0 1-6.51 2.05c-5.05.5-7.27-2-11.87-3.24-9.06-2.35-17.74 2.71-20.5 4.32-4.52 2.63-8.32 7.8-10.39 10.52 17.4-.01 35.23-.47 52.62-.44h0z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.43 192.94 29.22 60.29 35.05-9.29c-10.18-31.8-25.17-71.59-27.45-76.44-4.69-10-16.7-18-16.7-18",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#55F99F",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.46 41.18a84.59 84.59 0 0 1-4.65 27.59c-6 17.14-14.18 21.91-12.75 32.63 1.53 11.56 12.76 18.92 17.05 21.73 2.7 1.77 10.15 6.25 33.62 8.14 26.38 2.13 42.14 3.4 56.07-7.21a45.71 45.71 0 0 0 13.06-15.83c6.24-12.51 4.33-24.62.26-48.34-3.63-21.1-5.58-31.82-12.55-39.86-9.89-11.43-23-14.67-29.21-16.22-8.63-2.13-29.25-7.24-45.3 5.63-13.35 10.71-15.24 27.21-15.6 31.74z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41 88.35c1.1.64 3.06 51.17 3.67 61.4.61 10.23-7.19 27.7-23.42 28.68-16.23.98-10.39-25.59-4.92-34.77l-3.13-52.23 27.8-3.08z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.6 85.45-30.68 3.4 1.69 28.24c7.71 7.48 17.08 7.69 24.84 6.85a20.72 20.72 0 0 0 6.7-2c-.86-17.78-1.86-36.09-2.55-36.49z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.04 7.98s-16.28 21.68-13.78 64.37c2.5 42.69 22 47 36.47 46.28 14.47-.72 30.15-10.23 41.05-41.77 7.49-21.67-1.82-60.53-26.29-67.89-24.47-7.36-33.29-6.55-37.45-.99h0z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.68 52.11a5.21 5.21 0 0 1 2.81-2.72 5.28 5.28 0 0 1 4.3.25m22.8-1.59a5.12 5.12 0 0 1 7.31 1.82m-17.1 14.79s-3.5 7-5 9.12c-1.5 2.12-1.26 5.79 4.49 4.92",
    stroke: "#12186D",
    strokeWidth: 1.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 322.85,
    cy: 58.65,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#12186D",
    fillRule: "nonzero",
    cx: 297.78,
    cy: 59.76,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57 26.25a54.75 54.75 0 0 1-9 12.58 55.56 55.56 0 0 1-18.9 12.9 51.4 51.4 0 0 1 1.12-28.08c1.49-4.43 3.5-10.36 8.89-15.23 8.48-7.67 19.59-7.49 29-7.34 10.73.17 23.75.38 34.86 9.12 10 7.89 13.84 19.07 20.52 38.68 2.14 6.26 3.54 11.55 4.41 15.14a77.75 77.75 0 0 1-30.43-4.48c-23.74-8.61-36.26-26.58-40.47-33.29z",
    fill: "#12186D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.73 80.35c.26.22 4.91 4 9.94 2.21 5.03-1.79 6.17-7.95 6.43-9.49a10.92 10.92 0 0 0-.77-7c-.34-.69-2.32-4.68-6.61-5.21a8.62 8.62 0 0 0-6.52 2.15m-47.87 27.73a11.36 11.36 0 0 0 1.56 3.26 11.65 11.65 0 0 0 20.67-10.27l-22.23 7.01z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.24 308.35h511.5",
    stroke: "#12186D",
    strokeWidth: 6.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18 295.5H107.39l-9-114.48a4.36 4.36 0 0 1 4.05-4.61h165a4.36 4.36 0 0 1 4.05 4.61l8.69 114.48z",
    stroke: "#12186D",
    strokeWidth: 1.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74 295.51H362c0 5.904-4.786 10.69-10.69 10.69h-236.4a8.17 8.17 0 0 1-8.17-8.17v-2.52z",
    stroke: "#12186D",
    strokeWidth: 1.18,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.05 294h255.23c0 5.904-4.786 10.69-10.69 10.69H112.22a8.17 8.17 0 0 1-8.17-8.17V294z",
    fill: "#55F99F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.36 246.15c.14 2.55-1.53 3.86-4.88 3.86h-8.6l-.72-13.89h8.31c3.25 0 5 1.27 5.12 3.74a2.77 2.77 0 0 1-2 3 3.33 3.33 0 0 1 2.76 3.27l.01.02zm-10.74-4.51h5.07c1.22 0 1.79-.45 1.74-1.37-.05-.92-.66-1.43-1.85-1.43h-5.11l.15 2.8zm7.47 4.16c-.05-1-.71-1.42-2-1.42h-5.36l.16 2.87h5.39c1.24 0 1.83-.47 1.78-1.45h.03zm5.68-.96c-.17-3.24 2.08-5.41 5.64-5.41 3.56 0 6 2.17 6.21 5.41.21 3.24-2.09 5.42-5.64 5.42s-6-2.17-6.21-5.42m8.72 0a2.82 2.82 0 0 0-2.95-2.88 2.5 2.5 0 0 0-2.65 2.88 2.82 2.82 0 0 0 3 2.88 2.5 2.5 0 0 0 2.65-2.88m5.53-9.33h3.06l.76 14.5h-3.06zm15.79 14.11a6.32 6.32 0 0 1-3 .64c-2.65 0-4-1.07-4.11-3.25l-.26-5h-2.45l-.13-2.3h2.5l-.19-3.56h3.06l.19 3.56h3.57l.13 2.3h-3.62l.23 4.38c0 1 .5 1.36 1.56 1.36a3.91 3.91 0 0 0 1.84-.45l.68 2.32z",
    fill: "#2B296E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#23D5AE",
    strokeWidth: 2.27,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m141.42 243.77-.26-4.93 2.17-2.07 2.14-2.08 2.38 2.08 2.39 2.07.26 4.93zm9.34 4.94-.26-4.94h9.08l.26 4.94-2.18 2.07-2.15 2.07-2.39-2.07z"
  }))));
};

export default SvgStep2;